import { ConversationList } from './ConversationList';

export const conversations = {
  list: ConversationList,
};
